import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => ({

});

const withConnect = connect(mapStateToProps, null, null, { pure: false });

export default withConnect;